// extracted by mini-css-extract-plugin
export default {"row":"GridPurchases_row__tGxgI","rowHeader":"GridPurchases_rowHeader__LdxMn","rowSubHeader":"GridPurchases_rowSubHeader__2SyD6","rowValue":"GridPurchases_rowValue__1K5uT"};